// ===================== //
// === Enums and Types === //
// ===================== //

/**
 * 🎨 Icon Types
 * A `const` object representing the available icon types in the application.
 * Each key is a unique identifier, and its value corresponds to the string used for the icon.
 */

export const IconTypes = {
  Activity: 'activity',
  Airplay: 'airplay',
  AlertCircle: 'alert-circle',
  AlertOctagon: 'alert-octagon',
  AlertTriangle: 'alert-triangle',
  AlignCenter: 'align-center',
  AlignJustify: 'align-justify',
  AlignLeft: 'align-left',
  AlignRight: 'align-right',
  Anchor: 'anchor',
  Aperture: 'aperture',
  Archive: 'archive',
  ArrowDownCircle: 'arrow-down-circle',
  ArrowDownLeft: 'arrow-down-left',
  ArrowDownRight: 'arrow-down-right',
  ArrowDown: 'arrow-down',
  ArrowLeftCircle: 'arrow-left-circle',
  ArrowLeft: 'arrow-left',
  ArrowRightCircle: 'arrow-right-circle',
  ArrowRight: 'arrow-right',
  ArrowUpCircle: 'arrow-up-circle',
  ArrowUpLeft: 'arrow-up-left',
  ArrowUpRight: 'arrow-up-right',
  ArrowUp: 'arrow-up',
  AtSign: 'at-sign',
  Award: 'award',
  BarChart2: 'bar-chart-2',
  BarChart: 'bar-chart',
  BatteryCharging: 'battery-charging',
  BellOff: 'bell-off',
  Battery: 'battery',
  Bluetooth: 'bluetooth',
  Bell: 'bell',
  BookOpen: 'book-open',
  Book: 'book',
  Bold: 'bold',
  Bookmark: 'bookmark',
  Calendar: 'calendar',
  Box: 'box',
  Briefcase: 'briefcase',
  CameraOff: 'camera-off',
  Cast: 'cast',
  CheckSquare: 'check-square',
  CheckCircle: 'check-circle',
  Check: 'check',
  Camera: 'camera',
  ChevronDown: 'chevron-down',
  ChevronLeft: 'chevron-left',
  ChevronRight: 'chevron-right',
  ChevronUp: 'chevron-up',
  ChevronsDown: 'chevrons-down',
  Clock: 'clock',
  ChevronsRight: 'chevrons-right',
  Chrome: 'chrome',
  ChevronsUp: 'chevrons-up',
  Circle: 'circle',
  CircleFilled: 'circle-filled',
  CloudDrizzle: 'cloud-drizzle',
  ChevronsLeft: 'chevrons-left',
  Clipboard: 'clipboard',
  CloudLightning: 'cloud-lightning',
  CloudSnow: 'cloud-snow',
  Code: 'code',
  CloudRain: 'cloud-rain',
  Cloud: 'cloud',
  Codesandbox: 'codesandbox',
  CloudOff: 'cloud-off',
  Columns: 'columns',
  Codepen: 'codepen',
  Compass: 'compass',
  Coffee: 'coffee',
  Command: 'command',
  Copy: 'copy',
  CornerDownLeft: 'corner-down-left',
  CornerDownRight: 'corner-down-right',
  CornerRightUp: 'corner-right-up',
  CornerLeftDown: 'corner-left-down',
  CornerRightDown: 'corner-right-down',
  CornerLeftUp: 'corner-left-up',
  Cpu: 'cpu',
  CreditCard: 'credit-card',
  CornerUpRight: 'corner-up-right',
  Crosshair: 'crosshair',
  CornerUpLeft: 'corner-up-left',
  Disc: 'disc',
  Database: 'database',
  Crop: 'crop',
  DivideSquare: 'divide-square',
  Delete: 'delete',
  Divide: 'divide',
  DivideCircle: 'divide-circle',
  DollarSign: 'dollar-sign',
  DownloadCloud: 'download-cloud',
  Droplet: 'droplet',
  Download: 'download',
  Dribbble: 'dribbble',
  Edit: 'edit',
  ExternalLink: 'external-link',
  Edit3: 'edit-3',
  Edit2: 'edit-2',
  EyeOff: 'eye-off',
  Eye: 'eye',
  FastForward: 'fast-forward',
  Facebook: 'facebook',
  Figma: 'figma',
  FileMinus: 'file-minus',
  Feather: 'feather',
  FilePlus: 'file-plus',
  FileText: 'file-text',
  File: 'file',
  Film: 'film',
  Filter: 'filter',
  Flag: 'flag',
  FolderPlus: 'folder-plus',
  Folder: 'folder',
  Framer: 'framer',
  FolderMinus: 'folder-minus',
  Gift: 'gift',
  GitBranch: 'git-branch',
  Frown: 'frown',
  GitCommit: 'git-commit',
  GitPullRequest: 'git-pull-request',
  GitMerge: 'git-merge',
  Github: 'github',
  Gitlab: 'gitlab',
  Grid: 'grid',
  Globe: 'globe',
  Headphones: 'headphones',
  HardDrive: 'hard-drive',
  Heart: 'heart',
  HelpCircle: 'help-circle',
  Home: 'home',
  Hash: 'hash',
  Inbox: 'inbox',
  Hexagon: 'hexagon',
  Info: 'info',
  Italic: 'italic',
  Image: 'image',
  Key: 'key',
  Instagram: 'instagram',
  Layers: 'layers',
  Layout: 'layout',
  LifeBuoy: 'life-buoy',
  Link: 'link',
  Link2: 'link-2',
  Linkedin: 'linkedin',
  List: 'list',
  Loader: 'loader',
  LogOut: 'log-out',
  LogIn: 'log-in',
  Lock: 'lock',
  MapPin: 'map-pin',
  Mail: 'mail',
  Map: 'map',
  Maximize: 'maximize',
  MessageCircle: 'message-circle',
  Menu: 'menu',
  Maximize2: 'maximize-2',
  Meh: 'meh',
  Mic: 'mic',
  MinusCircle: 'minus-circle',
  Minus: 'minus',
  MessageSquare: 'message-square',
  Monitor: 'monitor',
  MicOff: 'mic-off',
  Moon: 'moon',
  Minimize2: 'minimize-2',
  MinusSquare: 'minus-square',
  MoreHorizontal: 'more-horizontal',
  MoreVertical: 'more-vertical',
  MousePointer: 'mouse-pointer',
  Minimize: 'minimize',
  Move: 'move',
  Music: 'music',
  Navigation2: 'navigation-2',
  Navigation: 'navigation',
  Octagon: 'octagon',
  Package: 'package',
  Paperclip: 'paperclip',
  PauseCircle: 'pause-circle',
  Pause: 'pause',
  PhoneCall: 'phone-call',
  Percent: 'percent',
  PenTool: 'pen-tool',
  PhoneIncoming: 'phone-incoming',
  PhoneMissed: 'phone-missed',
  PhoneForwarded: 'phone-forwarded',
  PhoneOutgoing: 'phone-outgoing',
  PieChart: 'pie-chart',
  PlayCircle: 'play-circle',
  PhoneOff: 'phone-off',
  Play: 'play',
  Phone: 'phone',
  PlusSquare: 'plus-square',
  PlusCircle: 'plus-circle',
  Plus: 'plus',
  Power: 'power',
  Radio: 'radio',
  RefreshCcw: 'refresh-ccw',
  Pocket: 'pocket',
  Printer: 'printer',
  RefreshCw: 'refresh-cw',
  Repeat: 'repeat',
  RotateCw: 'rotate-cw',
  Save: 'save',
  Rss: 'rss',
  RotateCcw: 'rotate-ccw',
  Search: 'search',
  Scissors: 'scissors',
  Send: 'send',
  Rewind: 'rewind',
  Server: 'server',
  Settings: 'settings',
  Share2: 'share-2',
  Share: 'share',
  ShieldOff: 'shield-off',
  Shield: 'shield',
  ShoppingCart: 'shopping-cart',
  Shuffle: 'shuffle',
  Sidebar: 'sidebar',
  SkipBack: 'skip-back',
  ShoppingBag: 'shopping-bag',
  SkipForward: 'skip-forward',
  Slack: 'slack',
  Slash: 'slash',
  Smartphone: 'smartphone',
  Sliders: 'sliders',
  Smile: 'smile',
  Square: 'square',
  Star: 'star',
  StopCircle: 'stop-circle',
  Sunset: 'sunset',
  Sunrise: 'sunrise',
  Speaker: 'speaker',
  Target: 'target',
  Terminal: 'terminal',
  Sun: 'sun',
  Tag: 'tag',
  Table: 'table',
  Tablet: 'tablet',
  ThumbsDown: 'thumbs-down',
  ToggleLeft: 'toggle-left',
  ThumbsUp: 'thumbs-up',
  Trash2: 'trash-2',
  Thermometer: 'thermometer',
  ToggleRight: 'toggle-right',
  Trash: 'trash',
  Tool: 'tool',
  TrendingDown: 'trending-down',
  Trello: 'trello',
  TrendingUp: 'trending-up',
  Triangle: 'triangle',
  Twitch: 'twitch',
  Twitter: 'twitter',
  Truck: 'truck',
  Umbrella: 'umbrella',
  Underline: 'underline',
  Tv: 'tv',
  Unlock: 'unlock',
  Type: 'type',
  Upload: 'upload',
  UserPlus: 'user-plus',
  UserCheck: 'user-check',
  UploadCloud: 'upload-cloud',
  User: 'user',
  UserX: 'user-x',
  UserMinus: 'user-minus',
  Video: 'video',
  VideoOff: 'video-off',
  Voicemail: 'voicemail',
  Users: 'users',
  VolumeX: 'volume-x',
  Volume1: 'volume-1',
  Volume2: 'volume-2',
  Volume: 'volume',
  Watch: 'watch',
  WifiOff: 'wifi-off',
  Wifi: 'wifi',
  Wind: 'wind',
  XCircle: 'x-circle',
  XSquare: 'x-square',
  XOctagon: 'x-octagon',
  X: 'x',
  Youtube: 'youtube',
  ZoomIn: 'zoom-in',
  Zap: 'zap',
  ZapOff: 'zap-off',
  ZoomOut: 'zoom-out',
} as const

/**
 * 🎭 IconKeysType
 * A dynamically derived type representing all the keys of `IconTypes` (e.g., 'Activity', 'Airplay').
 */
export type IconKeysType = keyof typeof IconTypes

/**
 * 🎭 IconValuesType
 * A dynamically derived type representing all the string values of `IconTypes` (e.g., 'activity', 'airplay').
 */
export type IconValuesType = (typeof IconTypes)[IconKeysType]

// ===================== //
// === Storybook Lists === //
// ===================== //

/*
 * 📚 Storybook Controls
 * Exported lists for Storybook dropdown controls.
 */
export const storybookIconsList: IconValuesType[] = Object.values(IconTypes)
